module.exports = __webpack_public_path__ + "img/stretch.33c72a75.jpg";